import { useEffect } from "react";
import { useHistory } from "react-router";
// Components
import BannerOne from "../../../components/BannerOne";

// Constants
import { TITLE, GOALS, HOW, WHAT, REQUIREMENTS, SALES_COVERS, SALES_SPECIALIST_COVERS, ACHIEVEMENTS} from "./PartnerSalesSpecialistEnablementConstants";


// Images
import salesBadge from '../../../assets/img/partnerPortal/EnablementSales/salesBadge.png';
import salesSpecialistBadge from '../../../assets/img/partnerPortal/EnablementSales/sales_specialist.png';
import goals from '../../../assets/img/partnerPortal/EnablementSales/goals.svg';
import selfPaced from '../../../assets/img/partnerPortal/EnablementSales/selfPaced.svg';
import info from '../../../assets/img/partnerPortal/EnablementSales/info.svg';
import salesEnablementWave from '../../../assets/img/partnerPortal/EnablementSales/full wave.png';



// Scss
import '../../../assets/css/partnerPortal/appDeveloper.scss';
import '../../../assets/css/partnerPortal/salesEnablement.scss';
import '../../../assets/css/partnerPortal/sales.scss';
import '../../../assets/css/partnerPortal/welcome.scss';


import NewsSectionTwo from "../../../components/NewsSectionTwo";
import BadgeSection from "../../../components/BadgeSection";
import CardWithNoBorder from "../../../components/CardWithNoBorder";

function PartnerSalesSpecialistEnablement() {

  let history = useHistory();

  useEffect(() => {
    canYouHaveAccess();


  }, []);

  return (
    <>
        <div className="mb-3">
            <BannerOne bannerImage={salesEnablementWave} title={TITLE} hasNoButton={true} />
            <div className="containerAll">
                
                
                <div className="w-100 mt-5 mb-5 d-flex align-items-center flex-column">
                    <div className="d-flex align-items-start w-100">
                        <CardWithNoBorder icon={goals} eyeBrow={""} title={"Training objectives"} subTitle={GOALS} />
                        <CardWithNoBorder icon={selfPaced} eyeBrow={""} title={"How it’s done"} subTitle={HOW} />
                        <CardWithNoBorder icon={info} eyeBrow={""} title={"What you need"} subTitle={WHAT} />
                    </div>
                </div>

                <div className="width66 mb-5 mt-5">
                    <div className="introframeHeader">
                        Your enablement
                    </div>
                    <div className="introframeSubText">
                    <b>Requirements:</b>{REQUIREMENTS}
                    </div>

                    <div className="d-flex justify-content-center align-items-start align-self-stretch mt-5">
                        <BadgeSection badge={salesBadge} title="Sales Training" time="2.5" eyeBrow="self-paced" buttonLink="https://dt-url.net/my23sh" covers={SALES_COVERS} />
                        <BadgeSection badge={salesSpecialistBadge} title="Sales Specialist Training" time="4" eyeBrow="self-paced" buttonLink="https://dt-url.net/9j23sy" covers={SALES_SPECIALIST_COVERS} />
                    </div>
                </div>

                <div className="width66 mb-4 mt-5">
                    <div className="introframeHeader fontSize25">
                        Achievements & Badges
                    </div>
                    <div className="introframeSubText text-left">
                        <div >
                            {ACHIEVEMENTS}
                        </div>
                    </div>
                </div>

                {/* <div className="faqTitle">
                    <div className="faqHeader">
                        <div className="faqTitleText">What else?</div>         
                    </div>
                </div>
                <NewsSectionTwo title={TITLE_ONE} subTitle={SUB_TITLE_ONE} />
                <NewsSectionTwo title={TITLE_TWO} subTitle={SUB_TITLE_TWO} />             */}

            </div>

        </div >
    </>
  );


  function canYouHaveAccess() {
    try {
      if (process.env.REACT_APP_PROTECT_PAGE === "true" && window.top?.location.host !== process.env.REACT_APP_ALLOW_API) {
        console.log("You shall not pass");
        history.push('/not-found');
      }
    } catch (err) {
      

    }
  }

}

export default PartnerSalesSpecialistEnablement;

